/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFaceSmile: {
  name: 'face-smile';
  data: string;
} = {
  name: 'face-smile',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm-3.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-8.2 4.9a1 1 0 0 0-1.6 1.2A5.992 5.992 0 0 0 12 18a5.992 5.992 0 0 0 4.8-2.4 1 1 0 0 0-1.6-1.2A3.993 3.993 0 0 1 12 16a3.992 3.992 0 0 1-3.2-1.6Z" fill="currentColor"/></svg>`,
};
